import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useMixpanel } from 'react-mixpanel-browser';
import { useNavigate } from 'react-router-dom';

import { useLogout } from '@/api/userAccount';
import spotterSmartMooringImg from '@/assets/spotter-smartmooring.png';
import { useLoginRedirectUrl } from '@/hooks/useLoginRedirectUrl';

export const SpotterNotFound = ({ spotterId }: { spotterId?: string | null }) => {
    const { refetch: logout } = useLogout({ config: { enabled: false } });
    const loginUrl = useLoginRedirectUrl();
    const navigate = useNavigate();
    const mixpanel = useMixpanel();
    useEffect(() => {
        mixpanel?.track('Spotter not found', { spotterId });
    }, [mixpanel, spotterId]);

    return (
        <Container maxWidth={false}>
            <Stack
                direction="row"
                sx={{
                    mt: '10vh',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 3,
                }}
            >
                <Box
                    component="img"
                    sx={{ transform: 'rotate(134deg)', height: '200px' }}
                    src={spotterSmartMooringImg}
                />
                <Stack sx={{ alignItems: 'start' }}>
                    <Typography variant="h2" sx={{ ml: 1, mb: 2 }}>
                        Spotter {spotterId} not found
                    </Typography>
                    <Button variant="text" href="/">
                        Return to Map View
                    </Button>
                    <Button
                        onClick={async () => {
                            await logout();
                            mixpanel?.track('Logout');
                            mixpanel?.reset();
                            navigate(loginUrl);
                        }}
                        variant="text"
                        href={loginUrl}
                    >
                        Switch to a different account
                    </Button>
                </Stack>
            </Stack>
        </Container>
    );
};
